/* Mybe.GG — light stock filter and version sharing; no mutation text search. */
(() => {
  if (window.MybeVersionToolsReady) return;
  window.MybeVersionToolsReady = true;
  const state = new Map();
  const tools = new WeakSet();
  const shares = new WeakSet();

  function initTools(box) {
    if (tools.has(box)) return;
    const fieldset = box.closest('fieldset');
    const list = fieldset?.querySelector('.swatches');
    const toggle = box.querySelector('[data-mybe-available-only]');
    const count = box.querySelector('[data-mybe-version-count]');
    if (!list || !toggle || !count) return;
    tools.add(box);
    const key = box.dataset.mybePickerKey || '';
    if (state.has(key)) toggle.setAttribute('aria-pressed', String(state.get(key)));

    const sync = () => {
      const onlyStock = toggle.getAttribute('aria-pressed') === 'true';
      const entries = [...list.children].filter(node => node.querySelector('input[type="radio"]'));
      let available = 0;
      for (const li of entries) {
        const input = li.querySelector('input[type="radio"]');
        const inStock = !input.disabled && !input.classList.contains('disabled');
        if (inStock) available++;
        // The selected variant always stays visible, including when out of stock.
        li.hidden = onlyStock && !inStock && !input.checked;
      }
      count.textContent = `${available} of ${entries.length} versions in stock`;
      state.set(key, onlyStock);
    };
    toggle.addEventListener('click', () => {
      toggle.setAttribute('aria-pressed', String(toggle.getAttribute('aria-pressed') !== 'true'));
      sync();
    });
    fieldset.addEventListener('change', sync);
    sync();
  }

  function initShare(button) {
    if (shares.has(button)) return;
    const picker = button.closest('variant-selects');
    const label = button.querySelector('[data-mybe-copy-label]');
    const status = picker?.querySelector('[data-mybe-copy-status]');
    if (!picker || !label || !status) return;
    shares.add(button);
    let timer;
    button.addEventListener('click', async () => {
      const form = document.getElementById(picker.dataset.mybeFormId);
      const variantId = form?.querySelector('input[name="id"]')?.value;
      if (!variantId || !/^[0-9]+$/.test(variantId)) {
        status.textContent = 'This version is not available to share.';
        return;
      }
      const url = new URL(picker.dataset.mybeProductPath || location.pathname, location.href);
      url.searchParams.set('variant', variantId);
      try {
        if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(url.toString());
        else {
          const temp = document.createElement('textarea');
          temp.value = url.toString(); temp.setAttribute('readonly','');
          temp.style.cssText='position:fixed;left:-9999px;top:0;';
          document.body.append(temp); temp.select();
          const worked = document.execCommand('copy'); temp.remove();
          if (!worked) throw new Error('Copy unsupported');
        }
        label.textContent = 'Copied link!';
        status.textContent = 'Direct link to the selected version copied.';
      } catch (_error) {
        label.textContent = 'Unable to copy';
        status.textContent = 'Copy unavailable in this browser.';
      }
      clearTimeout(timer);
      timer = setTimeout(() => {label.textContent = 'Copy selected version link';},2200);
    });
  }

  function scan() {
    document.querySelectorAll('[data-mybe-version-tools]').forEach(initTools);
    document.querySelectorAll('[data-mybe-copy-version]').forEach(initShare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  document.addEventListener('shopify:section:load',scan);
  // Shopify replaces the picker markup on variant changes. The capture phase also
  // receives CustomEvent('variant:change') dispatched without bubbles by the theme.
  document.addEventListener('variant:change', () => requestAnimationFrame(scan), true);
  document.addEventListener('keydown', event => {
    if (event.key !== '/' && !(event.key?.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey))) return;
    const el=event.target;
    if (el?.isContentEditable || ['INPUT','TEXTAREA','SELECT'].includes(el?.tagName) || event.isComposing || event.altKey || event.shiftKey) return;
    const trigger=document.querySelector('.search-drawer-button[aria-controls="SearchDrawer"]');
    if (!trigger || trigger.getAttribute('aria-expanded') === 'true') return;
    event.preventDefault(); trigger.click();
  });
})();
